import _parseInt from 'lodash/parseInt';
import _toFinite from 'lodash/toFinite';
import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_GET_CARPARK_CUSTOMERS_LIST,
  CPM_GET_CARPARK_CUSTOMER,
  CPM_ADD_CARPARK_CUSTOMER,
  CPM_UPDATE_CARPARK_CUSTOMER,
  CPM_DELETE_CARPARK_CUSTOMER,
  CPM_GET_CARPARK_CUSTOMER_PARKINGS_LIST,
  CPM_GET_CARPARK_CUSTOMER_BOOKINGS_LIST,
  CPM_GET_CARPARK_CUSTOMER_OLD_PARKINGS_LIST,
  CPM_GET_CARPARK_CUSTOMER_ACCESSES_LIST,
  CPM_CREATE_CARPARK_CUSTOMER_ACCOUNT,
  CPM_DELETE_CARPARK_CUSTOMER_ACCOUNT,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize as deserializeAccess } from '../../../models/cpm/access';
import { deserialize as deserializeParking } from '../../../models/cpm/parking';
import { deserializeBooking } from '../../../models/cpm/booking';
import { deserialize } from '../../../models/cpm/customer';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmCarparkCustomer;
const cpmCarparkCustomer = (state = initialSettings, action) => {
  let key;
  let mutationResult;
  let customerId;
  // let wsPayload;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullCarpark' || action.target === 'currentCarpark') {
        return {
          ...state,
          list: { ...initialSettings.list },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
          createAccount: { ...initialSettings.createAccount },
          deleteAccount: { ...initialSettings.deleteAccount },
        };
      }
      if (action.target === 'listCarparkCustomers') {
        return {
          ...state,
          parkings: { ...initialSettings.parkings },
          accesses: { ...initialSettings.accesses },
        };
      }
      switch (action.target) {
        case 'addCarparkCustomer':
          key = 'add';
          break;
        case 'updateCarparkCustomer':
          key = 'update';
          break;
        case 'deleteCarparkCustomer':
          key = 'delete';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // LIST
    case CPM_GET_CARPARK_CUSTOMERS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_CUSTOMERS_LIST}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case `${CPM_GET_CARPARK_CUSTOMERS_LIST}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.listCustomers.entries),
            pageNumber: _parseInt(action.data.listCustomers.pageNumber),
            pageSize: _parseInt(action.data.listCustomers.pageSize),
            totalEntries: _parseInt(action.data.listCustomers.totalEntries),
            totalPages: _parseInt(action.data.listCustomers.totalPages),
          },
        },
      };
    // GET
    case CPM_GET_CARPARK_CUSTOMER:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case `${CPM_GET_CARPARK_CUSTOMER}_ERROR`:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_GET_CARPARK_CUSTOMER}_SUCCESS`:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.getCustomer),
        },
      };
    // ADD
    case CPM_ADD_CARPARK_CUSTOMER:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_ADD_CARPARK_CUSTOMER}_ERROR`:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case `${CPM_ADD_CARPARK_CUSTOMER}_SUCCESS`:
      mutationResult = action.data.addCustomer;
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
          },
        },
      };
    // UPDATE
    case CPM_UPDATE_CARPARK_CUSTOMER:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_UPDATE_CARPARK_CUSTOMER}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_CARPARK_CUSTOMER}_SUCCESS`:
      mutationResult = action.data.updateCustomer;
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
          },
        },
      };
    // DELETE
    case CPM_DELETE_CARPARK_CUSTOMER:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_DELETE_CARPARK_CUSTOMER}_ERROR`:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case `${CPM_DELETE_CARPARK_CUSTOMER}_SUCCESS`:
      mutationResult = action.data.deleteCustomer;
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
          },
        },
      };
    // LINK
    case CPM_CREATE_CARPARK_CUSTOMER_ACCOUNT:
      return {
        ...state,
        createAccount: {
          ...state.createAccount,
          done: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_CREATE_CARPARK_CUSTOMER_ACCOUNT}_ERROR`:
      return {
        ...state,
        createAccount: {
          ...state.createAccount,
          error: action.error,
        },
      };
    case `${CPM_CREATE_CARPARK_CUSTOMER_ACCOUNT}_SUCCESS`:
      mutationResult = action.data.createCustomerAccount;
      return {
        ...state,
        createAccount: {
          ...state.createAccount,
          done: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
          },
        },
      };
    // UNLINK
    case CPM_DELETE_CARPARK_CUSTOMER_ACCOUNT:
      return {
        ...state,
        deleteAccount: {
          ...state.deleteAccount,
          done: false,
          error: null,
          result: null,
        },
      };
    case `${CPM_DELETE_CARPARK_CUSTOMER_ACCOUNT}_ERROR`:
      return {
        ...state,
        deleteAccount: {
          ...state.deleteAccount,
          error: action.error,
        },
      };
    case `${CPM_DELETE_CARPARK_CUSTOMER_ACCOUNT}_SUCCESS`:
      mutationResult = action.data.deleteCustomerAccount;
      return {
        ...state,
        deleteAccount: {
          ...state.deleteAccount,
          done: true,
          result: {
            ...mutationResult,
            id: _toFinite(mutationResult.id),
          },
        },
      };
    // LIST PARKINGS
    case CPM_GET_CARPARK_CUSTOMER_PARKINGS_LIST:
      customerId = action.cbParams.customerId;
      return {
        ...state,
        parkings: {
          ...state.parkings,
          [customerId]: {
            loading: true,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_CUSTOMER_PARKINGS_LIST}_SUCCESS`:
      customerId = action.customerId;
      return {
        ...state,
        parkings: {
          ...state.parkings,
          [customerId]: {
            loading: false,
            data: deserializeParking(action.data.listParkings.entries),
          },
        },
      };
    case CPM_GET_CARPARK_CUSTOMER_OLD_PARKINGS_LIST:
      customerId = action.cbParams.customerId;
      return {
        ...state,
        oldParkings: {
          ...state.oldParkings,
          [customerId]: {
            loading: true,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_CUSTOMER_OLD_PARKINGS_LIST}_SUCCESS`:
      customerId = action.customerId;
      return {
        ...state,
        oldParkings: {
          ...state.oldParkings,
          [customerId]: {
            loading: false,
            data: deserializeParking(action.data.listParkings.entries),
          },
        },
      };
    // LIST BOOKINGS
    case CPM_GET_CARPARK_CUSTOMER_BOOKINGS_LIST:
      customerId = action.cbParams.customerId;
      return {
        ...state,
        bookings: {
          ...state.bookings,
          [customerId]: {
            loading: true,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_CUSTOMER_BOOKINGS_LIST}_SUCCESS`:
      customerId = action.customerId;
      return {
        ...state,
        bookings: {
          ...state.bookings,
          [customerId]: {
            loading: false,
            data: deserializeBooking(action.data.listBookings.entries),
          },
        },
      };
    // LIST ACCESSES
    case CPM_GET_CARPARK_CUSTOMER_ACCESSES_LIST:
      customerId = action.cbParams.customerId;
      return {
        ...state,
        accesses: {
          ...state.accesses,
          [customerId]: {
            loading: true,
            data: null,
          },
        },
      };
    case `${CPM_GET_CARPARK_CUSTOMER_ACCESSES_LIST}_SUCCESS`:
      customerId = action.customerId;
      return {
        ...state,
        accesses: {
          ...state.accesses,
          [customerId]: {
            loading: false,
            data: deserializeAccess(action.data.listAccesses.entries),
          },
        },
      };
    default:
      return state;
  }
};

export default cpmCarparkCustomer;



// WEBPACK FOOTER //
// ./reducers/cpm/carpark/carparkCustomer.js